import React, { Component } from "react";

import styled, { css } from 'styled-components/macro'
import * as PubSub from "pubsub-js";

import mobile from "../../theme/mobile";
import { MENU_ENTRY_CLICKED_EVENT, MENU_OPEN_EVENT } from "./MobileMenu";

const Container = styled.span`
  ${mobile`
    display: inline-flex;
    flex-direction: column;
    justify-content: space-between;
    height: 30px;
    width: 36px;
    cursor: pointer;
  `}
`;

const SingleBar = styled.span`
  ${mobile`
    position: relative;
    align-self: center;
    display: block;
    height: 20%;
    width: 100%;
    transition: 0.4s;
    margin: 3px 0;
    background-color: rgba(${p => p.theme.color.text.primary});
    ${p => p.index === 0 && p.openState
      ? css`
      -webkit-transform: rotate(-45deg) translate(-4px, 4px);
      transform: rotate(-45deg) translate(-6px, 6px);
      ` : null
    }
    ${p => p.index === 1 && p.openState
      ? css`opacity: 0;`
      : null
    }
    ${p => p.index === 2 && p.openState
      ? css`
        -webkit-transform: rotate(45deg) translate(-6px, -6px);
        transform: rotate(45deg) translate(-8px, -8px);
      ` : null
    }
  `}
`;

export default class MobileShowMenuButton extends Component {
  constructor() {
    super();
    this.state = {
      openState: false,
    };
    this._handleClick = this._handleClick.bind(this);
  }

  componentDidMount() {
    const menuEntryClickedEvent = (msg, data) => {
      console.debug(MENU_ENTRY_CLICKED_EVENT + " catched.");
      this._handleClick();
    };
    PubSub.subscribe(MENU_ENTRY_CLICKED_EVENT, menuEntryClickedEvent);
  }

  _handleClick() {
    this.setState({
      openState: !this.state.openState,
    }, () => PubSub.publish(MENU_OPEN_EVENT, this.state.openState));
  }

  render() {
    return (
      <Container onClick={ this._handleClick } openState={ this.state.openState }>
        { [0, 1, 2].map(bar => <SingleBar key={ bar } index={ bar } openState={ this.state.openState } />) }
      </Container>
    );
  }
}
